import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import i18nConfig from '@/i18n/init';
import { LanguageSyncService } from '@/services/languageSync';

export const i18nInstance = i18n.createInstance();

// Override initial language with synchronized value
const syncedLanguage = LanguageSyncService.initLanguage();

i18nInstance
  .use(HttpApi)
  .use(detector)
  .use(initReactI18next)
  .init({
    ...i18nConfig,
    lng: syncedLanguage, // Use synced language
  })
  .then(() => {
    const lng = (i18nInstance.language || 'es').slice(0, 2);
    document.documentElement.setAttribute('lang', lng);
  });

// Sync language changes TO other contexts (MFE)
i18nInstance.on('languageChanged', (lng: string) => {
  document.documentElement.setAttribute('lang', (lng || 'es').slice(0, 2));
  LanguageSyncService.setLanguage(lng as 'es' | 'en');
});
